import { FIELD_PATHS } from './fieldPaths';

export enum INCOME_TYPE {
  GOVT_BENEFIT = 'GOVT_BENEFIT',
  CHILD_MAINTENANCE = 'CHILD_MAINTENANCE',
  FOREIGN_INCOME = 'FOREIGN_INCOME',
  INVESTMENT_INCOME = 'INVESTMENT_INCOME',
  OTHER_INCOME = 'OTHER_INCOME',
  PAYG_ALLOWANCES_NOT_TAXED = 'PAYG_ALLOWANCES_NOT_TAXED',
  PAYG_ALLOWANCES_TAXED = 'PAYG_ALLOWANCES_TAXED',
  PAYG_BASE_SALARY = 'PAYG_BASE_SALARY',
  PAYG_BONUS_INCOME = 'PAYG_BONUS_INCOME',
  PAYG_CAR_ALLOWANCE = 'PAYG_CAR_ALLOWANCE',
  PAYG_COMMISSION_INCOME = 'PAYG_COMMISSION_INCOME',
  PAYG_COMPANY_CAR = 'PAYG_COMPANY_CAR',
  PAYG_NON_VOLUNTARY_DEDUCTIONS_PRE_TAX = 'PAYG_NON_VOLUNTARY_DEDUCTIONS_PRE_TAX',
  PAYG_OVERTIME_INCOME = 'PAYG_OVERTIME_INCOME',
  PAYG_SALARY_SACRIFICE = 'PAYG_SALARY_SACRIFICE',
  RENTAL_INCOME = 'RENTAL_INCOME',
  SELF_EMPLOYED_BUSINESS_INCOME = 'SELF_EMPLOYED_BUSINESS_INCOME',
  SELF_EMPLOYED_BUSINESS_INCOME_FULL_DOC = 'SELF_EMPLOYED_BUSINESS_INCOME_FULL_DOC',
  SELF_EMPLOYED_BUSINESS_INCOME_LOW_DOC = 'SELF_EMPLOYED_BUSINESS_INCOME_LOW_DOC',
  SUPER_ANNUITY_PENSION = 'SUPER_ANNUITY_PENSION',
  WORKERS_COMPENSATION = 'WORKERS_COMPENSATION',
}

export enum GOVT_BENEFIT_TYPE {
  AGE_PENSION = 'AGE_PENSION',
  DISABILITY_SUPPORT_PENSION = 'DISABILITY_SUPPORT_PENSION',
  FAMILY_TAX = 'FAMILY_TAX',
}

export const BUSINESS_FULL_DOC_INCOME_ITEMS = {
  profit: {
    label: 'Company profit before tax',
    path: FIELD_PATHS.INCOME_BUSINESS_INCOME_COMPANY_PROFIT_BEFORE_TAX,
    allowNegativeValue: true,
    tooltip: 'You can also capture loss amount here.',
  },
  depreciation: {
    label: 'Depreciation',
    path: FIELD_PATHS.INCOME_BUSINESS_INCOME_ADD_BACK_DEPRECIATION,
    allowNegativeValue: false,
    tooltip:
      'Depreciation is a tax deduction, however it is not a day-to-day cash expense. The amount of allowance varies depending on the nature of asset being depreciated.',
  },
  salary: {
    label: 'Director salary',
    path: FIELD_PATHS.INCOME_BUSINESS_INCOME_ADD_BACK_SALARY,
    allowNegativeValue: false,
    tooltip:
      'Wage/income paid to all Directors from the business. Business Ownership % shading will be applied to this figure in servicing and the figure captured here should be entered accordingly.',
  },
  expenses: {
    label: 'Non-recurring expenses',
    path: FIELD_PATHS.INCOME_BUSINESS_INCOME_ADD_BACK_NON_RECURRING_EXPENSES,
    allowNegativeValue: false,
    tooltip: 'One off extraordinary expense e.g. a new piece of machinery or technology.',
  },
  superannuation: {
    label: 'Superannuation (Excess)',
    path: FIELD_PATHS.INCOME_BUSINESS_INCOME_ADD_BACK_SUPERANNUATION_EXCESS,
    allowNegativeValue: false,
    tooltip:
      'Superannuation paid to the borrower, in excess of any statutory requirements. Not for superannuation paid to employees.',
  },
  lease: {
    label: 'Lease',
    path: FIELD_PATHS.INCOME_BUSINESS_INCOME_ADD_BACK_LEASE,
    allowNegativeValue: false,
    tooltip:
      'Business or investment loan interest that you have paid, where the lease has ceased or is being refinanced.',
  },
  interest: {
    label: 'Interest',
    path: FIELD_PATHS.INCOME_BUSINESS_INCOME_ADD_BACK_INTEREST,
    allowNegativeValue: false,
    tooltip:
      'Business or investment loan interest that you have paid,  where the loan has been closed or is being refinanced.',
  },
  other: {
    label: 'Other',
    path: FIELD_PATHS.INCOME_BUSINESS_INCOME_ADD_BACK_OTHER,
    allowNegativeValue: false,
    tooltip: 'Anything else that is able to be added back that is not covered already.',
  },
  deduction: {
    label: 'Non-recurring income',
    path: FIELD_PATHS.INCOME_BUSINESS_INCOME_DEDUCTION,
    allowNegativeValue: false,
    tooltip:
      'Lumpsum or regular payments in the period being assessed that is not likely to reoccur or continue e.g. government assistance (such as Job Keeper), cashflow boost or one off transactions like the sale of assets.',
  },
};
